//
//
//
//
//
//
//
//
//
//

export default {
  model: {
    prop: 'checked',
    event: 'change'
  },
  props: {
    checked: {
      type: [String, Boolean],
      required: true
    },
    value: {
      type: [String, Boolean],
      default: ''
    }
  },

  computed: {
    isChecked() {
      return this.checked == this.value
    }
  },

  methods: {
    updateInput() {
      this.$emit('change', this.value)
    }
  }
}
